import axios from 'axios';
('use strict');

//
// formulaire d'inscription à la NL : Christophe Bernard
//

const inscription = {
	init() {
		if (document.querySelector('.inscription')) {
			this.constructor();
			this.removeRadioButton();
			// fonction de developpement pour tester les formulaires
			this.devTestTools(false);

			this.buttonSumit.onclick = (e) => {
				e.preventDefault();
				this.sendForm();
			};
		}
	},

	constructor() {
		this.form = document.querySelector('form')
		this.buttonSumit = document.querySelector('.inscription_submit');
		this.lastName = document.querySelector('input[name="newsletter_last_name"]');
		this.firstName = document.querySelector('input[name="newsletter_first_name"]');
		this.address = document.querySelector('input[name="newsletter_address"]');
		this.zipCode = document.querySelector('input[name="newsletter_zip_code"]');
		this.city = document.querySelector('input[name="newsletter_city"]');
		this.email = document.querySelector('input[name="newsletter_email"]');
		this.emailConfirm = document.querySelector('input[name="newsletter_email_confirm"]');
		this.birthday = document.querySelector('[data-newsletter-input="newsletter_birthday"]');
		this.birthday.day = document.querySelector('[data-newsletter-input="newsletter_birthday"] [data-inscription-periode="day"]');
		this.birthday.month = document.querySelector('[data-newsletter-input="newsletter_birthday"] [data-inscription-periode="month"]');
		this.birthday.year = document.querySelector(
			'[data-newsletter-input="newsletter_birthday"] [data-inscription-periode="year"]'
		);
		this.blogIdOrigin = document.querySelector('input[name=newsletter_blog_id_origin]');
		this.optinRgpd = document.querySelector('input[name="newsletter_optin_rgpd"]');
		this.optinSms = document.querySelector('input[data-newsletter-input="newsletter_optin_sms"]');
		this.phone = document.querySelector('input[name="newsletter_phone"]');
		// this.centres = document.querySelector('input[name="newsletter_centres"]');
		this.recaptcha = document.querySelector('.inscription_recaptcha');
		this.ml = document.querySelector('.form_ml');

		this.knowUsValid = false;

	},

	getCivility(input) {
		let civility = input.name == 'newsletter_civility' ? input.value : null;
		return civility;
	},

	getBirthday() {

		// console.log("function : get Birthday")

		let day = this.birthday.day.value;
		let month = this.birthday.month.value;
		let year = this.birthday.year.value;


		if (day.length <= 1 && day.length > 0) {
			day = '0' + day;
			parseInt(day)
		}

		if (month.length <= 1 && month.length > 0) {
			month = '0' + month;
			parseInt(month)
		}

		if (day && month && year) {
			this.birthday.dataset.newsletterBirthday = day + '/' + month + '/' + year;
		}

		// this.isValidDate(day, month, year)
	},

	isValidDate(day, month, year) {
		/** A REVOIR PROBLEME */
		let yearToCheck = parseInt(year);
		let monthToCheck = parseInt(month);
		let dateToCheck = parseInt(day);

		let dateObj = new Date();
		dateObj.setFullYear(yearToCheck, monthToCheck, dateToCheck);

		if (dateObj.getFullYear() == yearToCheck && (dateObj.getMonth() == monthToCheck) && dateObj.getDate() == dateToCheck) {
			console.log('ok', dateObj);
		} else {
			console.log('invalid', dateObj);
		}

	},

	removeRadioButton() {
		const containerKnowUs = document.querySelector('.inscription_knowUs')
		containerKnowUs.querySelector('input[type=text]').addEventListener('click', function () {
			containerKnowUs.querySelectorAll('input').forEach(radio => {
				radio.checked = false;
			})
		})

		containerKnowUs.querySelectorAll('input').forEach(radio => {
			radio.addEventListener('click', function () {
				containerKnowUs.querySelector('input[type=text]').value = "";
			})
		})
	},



	getAllDatas() {
		let dataToSend = new FormData();
		let fields = document.querySelectorAll('[data-newsletter-input^="newsletter"]');
		let centres = [];
		let knowUsReason = [];
		let birthdayDate = this.getBirthday();
		// console.log("date anniversaire", birthdayDate)

		fields.forEach((field) => {
			// pour les input à checker
			// console.log("nom = ", field.dataset.newsletterInput);
			let _input = field.querySelector('input');

			if (field.querySelector('input')) {
				switch (field.dataset.newsletterInput) {
					case 'newsletter_civility':
						// console.log('civilité => ', _input.value);
						dataToSend.append('newsletter_civility', _input.value);
						break;
					case 'newsletter_optin_rgpd':
						if (field.querySelector('input').checked) {
							// console.log('optin => ', _input.value);
							dataToSend.append('newsletter_optin_rgpd', _input.value);
						}
						break;
					case 'newsletter_optin_sms':
						if (field.querySelector('input').checked) {
							// console.log('sms ? ', _input.value);
							dataToSend.append('newsletter_optin_sms', _input.value);
						}
						break;
					case 'newsletter_knowUs':
						field.querySelectorAll('input').forEach(radio => {
							if (radio.getAttribute('type') === 'text') {
								if (radio.value != "") {
									// console.log(radio.value);
									dataToSend.append('newsletter_knowUs', radio.value);
									radio.checked = false;
								}
							}
							else if (radio.checked) {
								// console.log(radio.value);
								dataToSend.append('newsletter_knowUs', radio.value);
							}
						})
						break;
					case 'newsletter_centres':
						// console.log(field.querySelectorAll('input'))
						field.querySelectorAll('input').forEach(champ => {
							if (champ.checked) {
								// console.log(champ)
								centres = [...centres, champ.value];
							}
						})
						dataToSend.append('newsletter_centres', centres);

						break;
					default:
						break;
				}
			}


			// pour les inputs à remplir
			if (field.dataset.newsletterInput) {
				switch (field.dataset.newsletterInput) {
					case 'newsletter_last_name':
						// console.log('last_name => ', _input.value);
						dataToSend.append('newsletter_last_name', _input.value);
						break;
					case 'newsletter_first_name':
						// console.log('first_name => ', _input.value);
						dataToSend.append('newsletter_first_name', _input.value);
						break;
					case 'newsletter_email':
						// console.log('email => ', _input.value);
						dataToSend.append('newsletter_email', _input.value);
						break;
					case 'newsletter_email_confirm':
						// console.log('email_confirm => ', _input.value);
						dataToSend.append('newsletter_email_confirm', _input.value);
						break;
					case 'newsletter_city':
						// console.log('newsletter_city => ', _input.value);
						dataToSend.append('newsletter_city', _input.value);
						break;
					case 'newsletter_address':
						// console.log('newsletter_address => ', _input.value);
						dataToSend.append('newsletter_address', _input.value);
						break;
					case 'newsletter_phone':
						// console.log('phone => ', _input.value);
						dataToSend.append('newsletter_phone', _input.value);
						break;
					case 'newsletter_zip_code':
						// console.log('zip code => ', _input.value);
						dataToSend.append('newsletter_zip_code', _input.value);
						break;
					case 'newsletter_birthday':
						// console.log('BIRTHDAY => ',  birthday);
						let birthday = field.dataset.newsletterBirthday;
						dataToSend.append('newsletter_birthday', birthday)
						break;
					default:
						break;
				}

			}

			// ajout newsletter_blog_id_origin
			dataToSend.append('newsletter_blog_id_origin', this.blogIdOrigin.value)
			// recaptcha
			if (this.recaptcha && document.querySelector('.g-recaptcha')) {
				dataToSend.append('g-recaptcha-response', grecaptcha.getResponse());
			}
		});

		// console.log("centres => ", centres)
		return dataToSend;
	},

	sendForm() {
		const pathApi = apiData.SubscribeNewsletter;
		// this.knowUsForm()

		axios({
			url: pathApi,
			method: 'POST',
			data: this.getAllDatas()
		})
			.then((res) => {
				// console.log("connexion à l'API");

				if (res.data.code == 'error_validation') {
					this.errorForm(res.data);
				} else {
					this.successForm();
					this.form.reset();
				}
			})
			.catch((err) => {
				// console.error("Erreur de connexion à l'API", err)
			});
	},

	successForm() {
		const formulaire = document.querySelector('.inscription_formulaire');
		const intro = document.querySelector('.inscription_sucessMessage');
		intro.dataset.inscriptionSucess = true;
		formulaire.dataset.inscriptionSucess = true;
	},

	errorForm(erreur) {
		const { data, code, message } = erreur;
		const { errors } = data;

		const {
			newsletter_civility,
			newsletter_last_name,
			newsletter_first_name,
			newsletter_email,
			newsletter_email_confirm,
			newsletter_address,
			newsletter_zip_code,
			newsletter_city,
			newsletter_birthday,
			newsletter_phone,
			newsletter_optin_rgpd,
			// newsletter_optin_sms,
			newsletter_centres,
			newsletter_knowUs
		} = errors;

		// champs text
		this.ml.classList.add('form--error');
		newsletter_first_name ? this.errors.inputText(this.firstName, newsletter_first_name) : this.valid.inputText(this.firstName);
		newsletter_last_name ? this.errors.inputText(this.lastName, newsletter_last_name) : this.valid.inputText(this.lastName);
		newsletter_email ? this.errors.inputText(this.email, newsletter_email) : this.valid.inputText(this.email);
		newsletter_email_confirm ? this.errors.inputText(this.emailConfirm, newsletter_email_confirm) : this.valid.inputText(this.emailConfirm);
		newsletter_city ? this.errors.inputText(this.phone, newsletter_phone) : this.valid.inputText(this.city);
		newsletter_address ? this.errors.inputText(this.address, newsletter_address) : this.valid.inputText(this.address);
		newsletter_zip_code ? this.errors.inputText(this.zipCode, newsletter_zip_code) : this.valid.inputText(this.zipCode);
		newsletter_birthday ? this.errors.inputText(this.birthday, newsletter_birthday) : this.valid.inputText(this.birthday);
		newsletter_phone ? this.errors.inputText(this.phone, newsletter_phone) : this.valid.inputText(this.phone);
		newsletter_optin_rgpd ? this.errors.inputCheckbox(this.optinRgpd, newsletter_optin_rgpd) : this.valid.inputCheckbox(this.optinRgpd);
		// newsletter_optin_sms ? this.errors.inputCheckbox(this.optinSms, newsletter_optin_sms) : this.valid.inputCheckbox(this.optinSms);
		newsletter_centres ? this.errors.inputCentre(this.centres, newsletter_centres) : this.valid.inputCentre(this.centres);
		newsletter_knowUs ? this.errors.inputKnowUs(this.knowUs, newsletter_knowUs) : this.valid.inputKnowUs(this.knowUs);
		// reset recaptcha
		grecaptcha.reset();
	},

	errors: {
		inputText(element, message) {
			element.closest('.form_input').classList.add('form--error');
			element.parentElement.querySelector('.form_errorMessage').innerHTML = message;
		},
		inputDate(element, message) {
			element.closest('.form_input-date').classList.add('form--error');
			element.parentElement.querySelector('.form_errorMessage').innerHTML = message;
		},
		inputCheckbox(element, message) {
			element.closest('.form_checkbox').parentElement.classList.add('form--error');
			element.parentElement.parentElement.querySelector('.form_errorMessage').innerHTML = message;
		},
		inputCentre(element, message) {
			document.querySelector('.inscription_centres').classList.add('form--error');
			document.querySelector('.inscription_centres .form_errorMessage').innerHTML = message;
			document.querySelector('.inscription_centres .accordion').dataset.accordionState = 'open';
		},
		inputKnowUs(element, message) {
			document.querySelector('.inscription_knowUs').classList.add('form--error');
			document.querySelector('.inscription_knowUs .form_errorMessage').innerHTML = message;
		}
	},

	valid: {
		inputText(element) {
			element.closest('.form_input').classList.remove('form--error');
		},
		inputCheckbox(element) {
			element.closest('.form_checkbox').parentElement.classList.remove('form--error');
		},
		inputCentre(element) {
			document.querySelector('.inscription_centres').classList.remove('form--error');
		},
		inputKnowUs(element) {
			document.querySelector('.inscription_knowUs').classList.remove('form--error');
		}

	},

	devTestTools(switcher = true) {
		if (switcher) {
			this.lastName.value = 'Bernard';
			this.firstName.value = 'christophe';
			this.address.value = '21 rue du vert village';
			this.zipCode.value = '35000';
			this.city.value = 'Rennes';
			this.optinRgpd.checked = 1;
			this.optinSms.checked = 1;
			this.email.value = 'christophe@gmail.com';
			this.emailConfirm.value = 'christophe@gmail.com';
			this.birthday.day.value = '1';
			this.birthday.month.value = '1';
			this.birthday.year.value = '1982';
			this.phone.value = '0660342107';
			// submit
			this.sendForm();
		}
	}
};

export default inscription;



// WEBPACK FOOTER //
// ./src/scripts/components/inscription.js